import { useEffect } from 'react'
import Analytics from './Analytics'
import Header from './Header'
import Footer from './Footer'
import WhatsAppWidget from './WhatsAppWidget'

export default function Layout({ children, currentPath }) {
  useEffect(() => {
    const scrollToHash = () => {
      const targetId = decodeURIComponent(window.location.hash.slice(1))
      if (targetId) document.getElementById(targetId)?.scrollIntoView({ block: 'start' })
    }
    let animationFrame
    let settledFrame
    let settleTimer
    const scheduleHashScroll = () => {
      window.cancelAnimationFrame(animationFrame)
      window.cancelAnimationFrame(settledFrame)
      window.clearTimeout(settleTimer)
      animationFrame = window.requestAnimationFrame(() => {
        settledFrame = window.requestAnimationFrame(scrollToHash)
      })
      settleTimer = window.setTimeout(scrollToHash, 350)
    }
    scheduleHashScroll()
    window.addEventListener('load', scheduleHashScroll)
    window.addEventListener('hashchange', scheduleHashScroll)
    return () => {
      window.cancelAnimationFrame(animationFrame)
      window.cancelAnimationFrame(settledFrame)
      window.clearTimeout(settleTimer)
      window.removeEventListener('load', scheduleHashScroll)
      window.removeEventListener('hashchange', scheduleHashScroll)
    }
  }, [currentPath])

  return (
    <>
      <Analytics />
      <a className="skip-link" href="#main-content">Ir al contenido</a>
      <Header currentPath={currentPath} />
      <main id="main-content">{children}</main>
      <Footer />
      <WhatsAppWidget />
    </>
  )
}
